import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialSelect from "../../components/MasterSelect";
import { Box, Dialog } from "@mui/material";
import MaterialButton from "../../components/MaterialButton";
import colors from "../../assest/theme/base/colors";
import CloseIcon from "@mui/icons-material/Close";
import { EXPORT_BASE_URL, fetchAll, postItem } from "../../BaseUrl";
import { getallpostion } from "../Masters/PositionMaster/mutation";
import { utils, writeFile } from "xlsx";
import { ExportCSV, ExportPDF } from "../dashboard/Mutation";

const EXPORT_SCREENINGS_BY_STATUS = `
  query ExportScreeningsByStatus($status: String!, $export: String!) {
    exportScreeningsByStatus(status: $status, export: $export) {
      success
      message
      error
      downloadUrl
      fileName
      totalRecords
    }
  }
`;

const exportTypeoptions = [
  { label: "Excel", value: "excel" },
  { label: "CSV", value: "csv" },
];

const dashboardExportTypeoptions = [
  { label: "PDF", value: "pdf" },
  { label: "CSV", value: "csv" },
];

function ExportDialog({ open, onClose, data, setPopup, fileName, exportStatus, isFilter = false, fileterdownloadurl = '' , fileterdownloadurlCSV= '' }) {
  const [exportData, setExportData] = useState({
    fromDate: "",
    toDate: "",
    exportType: "",
    position: "",
    fromDateStatus: "unchecked",
    toDateStatus: "unchecked",
    positionStatus: "unchecked",
    exportTypeStatus: "unchecked",
  });
  const [positionoptions, setpositionoptions] = useState([]);

  // useEffect(() => {
  //   getpositionData();
  // }, []);

  const handleReportsChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...exportData };
    if (event?.target === undefined && selectEvent) {
      if (
        selectEvent.name === "status" ||
        selectEvent.name === "exportType" ||
        selectEvent.name === "position"
      ) {
        const lengthRegex = new RegExp("^.{1,50}$");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "fromDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "toDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setExportData(formState);
  };

  const resetForm = () => {
    setExportData({
      fromDate: "",
      toDate: "",
      exportType: "",
      fromDateStatus: "unchecked",
      toDateStatus: "unchecked",
      positionStatus: "unchecked",
      positionsStatus: "unchecked",
      usersStatus: "unchecked",
      statusStatus: "unchecked",
      exportTypeStatus: "unchecked",
    });
    onClose();
  };

  const isFormValid = () => {
    return (
      // exportData.fromDateStatus === "success" &&
      // exportData.toDateStatus === "success" &&
      exportData.exportTypeStatus === "success"
      // exportData.positionStatus === "success"
    );
  };

  // const getpositionData = async () => {
  //   try {
  //     const response = await fetchAll(getallpostion);
  //     if (response?.getAllPositions?.success === true) {
  //       const data = response?.getAllPositions?.data.map((v, i) => ({
  //         value: v?.id,
  //         label: v?.positionName,
  //       }));
  //       setpositionoptions(data);
  //     } else {
  //       setpositionoptions([]);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //   }
  // };


  const ExportFilter=(url,exportType)=>
  {
      if (url != '') {
            const link = document.createElement("a");
            link.href = url;
            link.download = `${fileName}_export.${exportType === "excel" ? "xlsx" : "csv"}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setPopup({
              open: true,
              message: `${exportData?.exportType?.label || "Export"} successful!`,
              severity: "success",
            });

            resetForm();
          }
          else {
            setPopup({
              open: true,
              message: "Export Failed.",
              severity: "error",
            });
            resetForm();
          }
  }

  const exportExcelData = () => {
    try {
      const exportType = exportData?.exportType?.value || "csv";

      if (fileName === "Dashboard") {
        if(isFilter)
        {
            if(exportType === 'csv')
            {
               ExportFilter(fileterdownloadurl,exportType)
            }
            else
            {
              window.open(fileterdownloadurlCSV, '_blank');
            }
        }
        else
        {
           if (exportType === "csv") {
          handleDownloadCsv();
        } else {
          handleDownloadPdf();
        }
        }
      } else if (exportStatus) {
        if (isFilter) {
           
           ExportFilter(fileterdownloadurl,exportType)

        }
        else {
          handleBackendStatusExport(exportStatus, exportType);
        }
      } else {
        const worksheet = utils.json_to_sheet(data);

        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Write file based on the export type
        if (exportType === "csv") {
          writeFile(workbook, `${fileName}.csv`, { bookType: "csv" });
        } else {
          writeFile(workbook, `${fileName}.xlsx`);
        }

        setPopup({
          open: true,
          message: `${exportData?.exportType?.label || "CSV"
            } export successful!`,
          severity: "success",
        });

        resetForm();
      }
    } catch (error) {
      console.error("An error occurred during export:", error);
      setPopup({
        open: true,
        message: "Export failed. Please try again.",
        severity: "error",
      });
    }
  };

  const handleBackendStatusExport = async (status, exportType) => {
    try {
      const variables = {
        status: status,
        export: exportType,
      };

      const response = await postItem(EXPORT_SCREENINGS_BY_STATUS, { ...variables });

      const resData = response?.exportScreeningsByStatus;

      if (resData?.success && resData?.downloadUrl) {
        let fullUrl = resData.downloadUrl;
        if (!fullUrl.startsWith('http')) {
          fullUrl = `${EXPORT_BASE_URL}${fullUrl.startsWith('/') ? '' : '/'}${fullUrl}`;
        }

        const link = document.createElement("a");
        link.href = fullUrl;
        link.download = resData.fileName || `${status}_export.${exportType === "excel" ? "xlsx" : "csv"}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setPopup({
          open: true,
          message: resData.message || `${exportData?.exportType?.label || "Export"} successful!`,
          severity: "success",
        });
      } else {
        setPopup({
          open: true,
          message: resData?.message || "Export failed. Please try again.",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error exporting by status:", error);
      setPopup({
        open: true,
        message: "Export failed.",
        severity: "error",
      });
    } finally {
      resetForm();
    }
  };

  const handleDownloadCsv = async () => {
    try {
      const response = await postItem(ExportCSV);

      const fileUrl = response?.exportAnalyticsCsv?.fileUrl;

      if (fileUrl) {
        const fullUrl = `${EXPORT_BASE_URL}${fileUrl}`;

        const link = document.createElement("a");
        link.href = fullUrl;
        link.download = "analyticsDashboard.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        //Success: Show popup
        setPopup({
          open: true,
          message: `CSV export successful!`,
          severity: "success",
        });
      } else {
        console.error("CSV URL not found.");

        setPopup({
          open: true,
          message: `CSV export failed. URL not found.`,
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error exporting analytics:", error);

      setPopup({
        open: true,
        message: `CSV export failed.`,
        severity: "error",
      });
    } finally {
      resetForm();
    }
  };

  const handleDownloadPdf = async () => {
    try {
      const payload = {
        isTeamBased: false,
      };

      const response = await postItem(ExportPDF, payload); // replace with your actual mutation variable

      const filePath = response?.generatePdf?.filePath;

      if (filePath) {
        // Add base URL if needed
        const fullUrl = `${EXPORT_BASE_URL}/${filePath}`;

        const link = document.createElement("a");
        window.open(fullUrl, "_blank");
        link.download = "analyticsDashboard.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setPopup({
          open: true,
          message: `PDF export successful!`,
          severity: "success",
        });
      } else {
        console.error("PDF path not found.");
        setPopup({
          open: true,
          message: `PDF export failed. URL not found.`,
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      setPopup({
        open: true,
        message: `CSV export failed.`,
        severity: "error",
      });
    } finally {
      resetForm();
    }
  };

  // const exportExcelData = async () => {
  //   const variables = {
  //     positionId: exportData.position.value,
  //     exportType: exportData.exportType.value,
  //   };
  //   try {
  //     const response = await postItem(EXPORTCLIENT, { filters: variables });
  //     if (response?.createposition?.success === true) {
  //       setPopup({
  //         open: true,
  //         message: response?.exportposition?.message,
  //         severity: "success",
  //       });
  //     } else {
  //       setPopup({
  //         open: true,
  //         message: response?.exportposition?.message,
  //         severity: "error",
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //   }
  // };

  // const exportExcelData = () => {
  //   const exportType = exportData?.exportType?.value;

  //   const dataToExport = fileName === "fileName" && [
  //     ...data?.screeningData,
  //     ...data?.interviewData,
  //     ...data?.onboardingData,
  //   ];

  //   const worksheet = utils.json_to_sheet(
  //     fileName === "fileName" ? dataToExport : data
  //   );
  //   const workbook = utils.book_new();
  //   utils.book_append_sheet(workbook, worksheet, "Sheet1");

  //   if (exportType === "csv") {
  //     // Write as CSV
  //     writeFile(workbook, `${fileName}.csv`, { bookType: "csv" });
  //   } else {
  //     // Write as Excel (default)
  //     writeFile(workbook, `${fileName}.xlsx`);
  //   }
  //   setPopup({
  //     open: true,
  //     message: `${exportData?.exportType?.label} export successfuly`,
  //     severity: "success",
  //   });
  //   resetForm();
  // };

  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "600px", // Set your desired width
          maxWidth: "none", // Prevent it from limiting the width to default sizes
          p: 2,
          borderRadius: "25px",
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2 }}>
        <CloseIcon
          onClick={onClose}
          fontSize="50px"
          sx={{ color: colors.black.main, fontSize: "30px", cursor: "pointer" }}
        />
      </Box>
      <Grid container spacing={4} p={2}>
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            From Date
            <span style={{ marginLeft: "2px", color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            name="fromDate"
            type="date"
            value={exportData.fromDate}
            onChange={handleReportsChange}
            error={exportData.fromDateStatus === "error" ? true : false}
            success={exportData.fromDateStatus === "success" ? true : false}
            inputProps={{
              max: new Date().toISOString().split("T")[0], // max today
            }}
          />
          {exportData.fromDateStatus === "error" && (
            <MaterialTypography
              variant="caption"
              color="error"
              sx={{ mt: 0.5, display: "block" }}
            >
              From Date Should be DD-MM-YYYY.
            </MaterialTypography>
          )}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            To Date
            <span style={{ marginLeft: "2px", color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            name="toDate"
            type="date"
            value={exportData.toDate}
            onChange={handleReportsChange}
            error={exportData.toDateStatus === "error" ? true : false}
            success={exportData.toDateStatus === "success" ? true : false}
            inputProps={{
              max: new Date().toISOString().split("T")[0], // max today
              min: exportData.fromDate || undefined, // min fromDate
            }}
          />
          {exportData.toDateStatus === "error" && (
            <MaterialTypography
              variant="caption"
              color="error"
              sx={{ mt: 0.5, display: "block" }}
            >
              To Date Should be DD-MM-YYYY.
            </MaterialTypography>
          )}
        </Grid> */}

        {/* <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            sx={{ color: colors.inputlabel }}
          >
            Position
            <span style={{ marginLeft: "2px", color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialSelect
            name="position"
            placeholder={`Select Position`}
            value={exportData.position}
            options={positionoptions}
            searchable={false}
            onChange={handleReportsChange}
            error={exportData.positionStatus === "error" ? true : false}
            success={exportData.positionStatus === "success" ? true : false}
          />
        </Grid> */}

        <Grid size={{ xs: 12, md: 12 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Export Type
            <span style={{ marginLeft: "2px", color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialSelect
            name="exportType"
            placeholder={`Select Export Type`}
            value={exportData.exportType}
            options={
              fileName === "Dashboard"
                ? dashboardExportTypeoptions
                : exportTypeoptions
            }
            searchable={false}
            onChange={handleReportsChange}
            error={exportData.exportTypeStatus === "error" ? true : false}
            success={exportData.exportTypeStatus === "success" ? true : false}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <Box display="flex" justifyContent="center" gap={5} mt={3.4}>
            <MaterialButton
              variant="contained"
              sx={{
                background: colors.buttonColor,
                color: "#fff",
                textTransform: "capitalize",
              }}
              disabled={!isFormValid()}
              onClick={exportExcelData}
            >
              Export
            </MaterialButton>
            <MaterialButton
              onClick={resetForm}
              variant="outlined"
              color="error"
            >
              Cancel
            </MaterialButton>
          </Box>
        </Grid>
      </Grid>
    </Dialog>
  );
}

export default ExportDialog;
